import { FunctionComponent } from 'react'
import { useHistory } from 'react-router'
import { Button, ConexaLogo } from '@conexasaude/conexa-hero'

import logoConexa from '@/assets/logo-conexa.svg'

import useStyles from './styles'
import { HeroWrapper } from '@/styles/rebranded/HeroWrapper'

interface LightHeaderProps {
  uniqueCode?: string
  logo?: string
  redirectTo: string
  hiddenButton?: boolean
}

const LightHeader: FunctionComponent<LightHeaderProps> = ({
  uniqueCode,
  redirectTo,
  hiddenButton,
}) => {
  const history = useHistory()
  const styles = useStyles()

  const goToLink = () => {
    history.push(redirectTo)
  }

  return (
    <HeroWrapper>
      <div css={styles.container}>
        <div className="container">
          <div className="row">
            <div className="col-12 d-flex justify-content-between">
              {uniqueCode && uniqueCode.toLocaleLowerCase() !== 'conexa' ? (
                <img
                  src={`${process.env.REACT_APP_LINK_LOGO_AWS}${uniqueCode}.png`}
                  onError={event => {
                    event.currentTarget.onerror = null
                    event.currentTarget.src = logoConexa
                    event.currentTarget.style.height = 'auto'
                  }}
                  height={'40px'}
                  alt="Conexa Saúde"
                />
              ) : (
                <ConexaLogo base="colorful" inverse width={130} height={48} />
              )}
              {hiddenButton || (
                <Button variant="secondary" onClick={goToLink}>
                  Voltar para o início
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </HeroWrapper>
  )
}

export { LightHeader }
